import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MeterDownloadWizardFilter } from '@app/shared/models/meter/meter-download-wizard-data';
import { TranslateService } from '@ngx-translate/core';
import { MeterDownloadWizardUtility } from '../meter-download-wizard-utility';

@Component({
  selector: 'app-meter-selection',
  templateUrl: './meter-selection.component.html',
  styleUrls: ['./meter-selection.component.scss'],
})
export class MeterSelectionComponent implements OnInit {
  @Input() filter: Partial<MeterDownloadWizardFilter> = {} as MeterDownloadWizardFilter;
  @Output() title = new EventEmitter<string>();
  @Output() nextButtonStatus = new EventEmitter<boolean>();
  @Output() meterSelection = new EventEmitter<string>();

  options = [
    { type: 'current', name: 'Der aktuell ausgewählte Zähler' },
    { type: 'multiple', name: 'Mehrere Zähler*' },
  ];

  constructor(public translate: TranslateService) {}

  public ngOnInit() {
    this.title.emit(this.translate.instant('module.shared.excelDownloadWizard.titleText2'));
    this.nextButtonStatus.emit(MeterDownloadWizardUtility.isNextButtonDisabled(this.filter.meterSelection));
  }

  public onSelectionChange(value: string) {
    this.meterSelection.emit(value);
    this.nextButtonStatus.emit(false);
  }
}
